// extracted by mini-css-extract-plugin
export default {"container":"styles_container__NCZnS","header":"styles_header__KQpkn","divider":"styles_divider__140AO","content":"styles_content__awxzY"};